import React from "react";

const AddComment = ({
  viewBox = "0 0 24 24",
  color = "#333",
  size = 24,
  ...props
}) => (
  <svg
    viewBox="0 0 1024 1024"
    p-id="4678"
    width={size}
    height={size}
    {...props}
  >
    <path
      d="M800 672m-224 0a224 224 0 1 0 448 0 224 224 0 1 0-448 0Z"
      fill={color}
      p-id="4679"
    ></path>
    <path
      d="M896 256v448H352c-14.08 0-27.52 4.48-38.4 12.8l-32 23.68a63.232 63.232 0 0 0-57.6-36.48H128V256h768m0-64H128c-35.2 0-64 28.8-64 64v448c0 35.2 28.8 64 64 64h96v96l128-96H896c35.2 0 64-28.8 64-64V256c0-35.2-28.8-64-64-64z"
      fill={color}
      p-id="4680"
    ></path>
    <path
      d="M320 448m-64 0a64 64 0 1 0 128 0 64 64 0 1 0-128 0Z"
      fill={color}
      p-id="4681"
    ></path>
    <path
      d="M512 448m-64 0a64 64 0 1 0 128 0 64 64 0 1 0-128 0Z"
      fill={color}
      p-id="4682"
    ></path>
    <path
      d="M704 448m-64 0a64 64 0 1 0 128 0 64 64 0 1 0-128 0Z"
      fill={color}
      p-id="4683"
    ></path>
    <path
      d="M864 640H832v-32c0-17.92-14.08-32-32-32s-32 14.08-32 32v32h-32c-17.92 0-32 14.08-32 32 0 17.28 14.08 32 32 32h32v32c0 17.28 14.08 32 32 32s32-14.72 32-32V704h32c17.92 0 32-14.72 32-32 0-17.92-14.08-32-32-32z"
      fill="#fff"
      p-id="4684"
    ></path>
  </svg>
);

export default AddComment;
